import Vue from 'vue'
const requests = {
  territories: null,
  borders: null,
  tree: null
}
export default {
  getInfrastructureObject({ getters, dispatch, commit }, id) {
    return Vue.http
      .get(getters.endpoint.infrastructureById(id), {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders[0]
        }
      })
      .then((r) => {
        if (r.body) {
          commit('setInfrastructureEdit', r.body)
        }
      })
  },
  updateInfrastructureObject({ getters, dispatch, commit }, params) {
    return Vue.http
      .put(getters.endpoint.infrastructureById(params.id), params, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        if (r.body) {
          commit('setInfrastructureEdit', r.body)
        }
      })
  },
  createInfrastructureObject({ getters, dispatch, commit }, params) {
    return Vue.http
      .post(getters.endpoint.infrastructure, params, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        if (r.body) {
          commit('setInfrastructureEdit', r.body)
          dispatch('getInfrastructurePanel')
        }
      })
  },
  deleteInfrastructureObject({ getters, dispatch, commit }, id) {
    return Vue.http.delete(getters.endpoint.infrastructureById(id), {
      params: {
        workspace: getters.workspace,
        version: getters.version
      }
    })
  },

  getInfrastructureTerritoriesMap({ commit, getters, dispatch }, params) {
    if (
      !(getters.objectMapParams && getters.objectsPeriod && getters.objectsPeriod.borders) ||
      getters.objectLayerSettings.zonegroup.settings.adm_level === -1
    ) {
      return Promise.resolve()
    }
    params = {
      zoom: getters.infrastructureMapParams.zoom
    }
    if (getters.infrastructureMapParams.zoom >= getters.settings.bbox_min_zoom) {
      params.square = getters.infrastructureMapParams.square
    }
    const requestParams = {
      ...params,
      adm_level: 20,
      [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(','),
      workspace: getters.workspace,
      version: getters.version
    }
    Vue.http
      .get(getters.endpoint.map.admterritory, {
        params: requestParams,
        before(request) {
          dispatch('abortInfrastructureMapRequest', { request, key: 'territory' })
        }
      })
      .then((r) => {
        requests.territories = null
        commit('updateInfrastructureMapData', {
          territories: r.body
        })
      })
      .catch((e) => {
        dispatch('handleInfrastructureMapErros', e)
      })
  },

  getInfrastructureBordersMap({ commit, getters, dispatch }) {
    if (getters.objectMapParams && getters.objectsPeriod && getters.objectsPeriod.borders) {
      Vue.http
        .get(getters.endpoint.map.admterritory, {
          params: {
            ...getters.infrastructureMapParams,
            [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(','),
            workspace: getters.workspace,
            version: getters.version,
            adm_level: 20
          },
          before(request) {
            dispatch('abortInfrastructureMapRequest', { request, key: 'borders' })
          }
        })
        .then((r) => {
          requests.borders = null
          commit('updateInfrastructureMapData', {
            borders: r.body
          })
        })
        .catch((e) => {
          dispatch('handleInfrastructureMapErros', e)
        })
    }
  },

  getInfrastructureTechnologies({ commit, getters, dispatch }) {
    return Vue.http
      .get(getters.endpoint.technologies, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          limit: 20000
        }
      })
      .then((r) => {
        r.body.results = r.body.results.map((v) => {
          return {
            ...v,
            name: v.name || 'Технология ' + v.id
          }
        })
        commit('setInfrastructureTechnologies', r.body.results)
      })
  },
  getInfrastructureTechnology({ commit, getters, dispatch }, id) {
    return Vue.http
      .get(getters.endpoint.technology(id), {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setInfrastructureTechnologyCreated', r.body)
        commit('setInfrastructureTechnology', r.body)
        return r.body
      })
  },

  updateInfrastructureTechnology({ commit, getters, dispatch }, params) {
    return Vue.http
      .put(getters.endpoint.technology(params.id), params, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        const technologies = getters.infrastructureTechnologies.concat([])
        const index = technologies.findIndex((t) => t.id === params.id)
        if (index > -1) {
          technologies[index] = r.body
        }
        commit('setInfrastructureTechnologies', technologies)
        return r.body
      })
  },

  createInfrastructureTechnology({ commit, getters, dispatch }, params) {
    return Vue.http
      .post(getters.endpoint.technologies, params, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        const technologies = getters.infrastructureTechnologies.concat([])
        technologies.push(r.body)
        commit('setInfrastructureTechnologies', technologies)
        commit('setInfrastructureTechnologyCreated', r.body)
        return r.body
      })
      .catch((e) => {
        console.log(e)
      })
  },

  getInfrastructureTechnologyTree({ commit, getters, dispatch }, params) {
    return Vue.http
      .get(getters.endpoint.technologyTree(params.id), {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          limit: 1000,
          period_id: params.periodId
        },
        before(request) {
          dispatch('abortInfrastructureMapRequest', { request, key: 'tree' })
        }
      })
      .then((r) => {
        requests.tree = null
        commit('setInfrastructureTechnologyTree', r.body.structure)
        return {
          structure: r.body.structure,
          message: r.body.message
        }
      })
      .catch((e) => {
        dispatch('handleInfrastructureMapErros', e)
      })
  },

  resetInfrastructureTechnologyTree({ commit, getters, dispatch }, params) {
    dispatch('abortInfrastructureMapRequest', { request: null, key: 'tree' })
    commit('setInfrastructureTechnologyTree', [])
  },

  abortInfrastructureMapRequest({}, params) {
    if (requests[params.key]) {
      requests[params.key].abort()
    }
    requests[params.key] = params.request
  },

  handleInfrastructureMapErros({}, e) {
    if (e.status === 0) {
      return
    }
    throw e
  }
}



// WEBPACK FOOTER //
// ./src/store/infrastructures/actions.js